package org.example.zone360.pages.dashboard.coaches

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxHeight
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.rowGap
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaXmark
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.layout.HorizontalDivider
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.example.zone360.utils.importCoach
import org.example.zone360.utils.importPlayer
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.launch
import org.example.zone360.components.CommonButton
import org.example.zone360.components.CustomSpacer
import org.example.zone360.components.SearchBar
import org.example.zone360.components.UploadingTextAnimation
import org.example.zone360.components.showToast
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.BulkCreatePlayerDetail
import org.example.zone360.models.BulkCreatePlayerResponse
import org.example.zone360.models.GetClubCoachesData
import org.example.zone360.models.GetPlayerData
import org.example.zone360.theme.SitePalette
import org.example.zone360.utils.Divider
import org.example.zone360.utils.Res
import org.example.zone360.utils.ToastID
import org.example.zone360.utils.extractTeamName
import org.example.zone360.utils.toFixed
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.accept
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Input
import org.w3c.dom.HTMLAnchorElement
import org.w3c.dom.HTMLInputElement
import org.w3c.dom.url.URL
import org.w3c.files.Blob
import org.w3c.files.BlobPropertyBag

@Composable
fun ImportEntity(
    sitePalette: SitePalette,
    breakpoint: Breakpoint,
    isCoach: Boolean,
    onDialogDismiss: () -> Unit,
    toastMessage: (String) -> Unit,
    buyCoaches: (Boolean) -> Unit,
    coachesData: List<GetClubCoachesData> = emptyList(),
    playerData: List<GetPlayerData> = emptyList(),
) {
    val scope = rememberCoroutineScope()
    val importDetails = remember { mutableStateListOf<BulkCreatePlayerDetail>() }
    var importedData by remember { mutableStateOf<BulkCreatePlayerResponse?>(null) }
    var isUploading by remember { mutableStateOf(false) }
    var hasUploaded by remember { mutableStateOf(false) }
    var showMore by remember { mutableStateOf(false) }
    var searchText by remember { mutableStateOf("") }
    val filteredImportedData = remember(searchText, importDetails) {
        if (searchText.isEmpty()) importDetails
        else importDetails.filter { data ->
            val email = data.email
            email.contains(searchText, ignoreCase = true)
        }
    }


    val entityName = if (isCoach) "Coaches" else "Players"
    val isSmallScreen = window.screen.width <= 1000

    // Main modal container
    Box(modifier = Modifier.fillMaxSize().backgroundColor(Colors.Gray.copyf(alpha = 0.6f))
        .zIndex(99),
        contentAlignment = Alignment.Center
    ) {
        Box(
            modifier = Modifier
                .width(if (isSmallScreen) 100.percent else 900.px)
            .position(Position.Fixed)
            .zIndex(9)
            .top(50.percent)
            .left(50.percent)
            .transform { translate((-50).percent, (-50).percent) },
            contentAlignment = Alignment.Center,
        ) {
            Box(
                modifier = Modifier
                    .padding(all = 24.px)
                    .width(95.percent)
                    .margin(top = 10.px)
                    .height(100.percent)
                    .backgroundColor(sitePalette.modalBackgroundColor.rgb)
                    .border(
                        width = 1.px,
                        color = sitePalette.textFieldBorderColor.rgb,
                        style = LineStyle.Solid
                    )
                    .borderRadius(4.px)
                    // Allow horizontal scroll if content overflows
                    .then(if (isSmallScreen) Modifier.overflow(Overflow.Auto) else Modifier),
                contentAlignment = Alignment.Center,
            ) {
                Column(modifier = Modifier.fillMaxWidth()) {
                    /** HEADER **/
                    Row(
                        horizontalArrangement = Arrangement.SpaceBetween,
                        modifier = Modifier.fillMaxWidth().margin(bottom = 20.px),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        FieldTitleTextNormalSimple(
                            "Import $entityName List",
                            fontSize = 20.px,
                            fontWeight = 600
                        )

                        FaXmark(
                            modifier = Modifier
                                .color(sitePalette.commonButtonSupportiveTextColor.rgb)
                                .cursor(Cursor.Pointer)
                                .onClick {
                                    if (isUploading) {
                                        toastMessage("Please wait for the file to upload")
                                        showToast(ToastID.ERROR)
                                        return@onClick
                                    }
                                    onDialogDismiss()
                                },
                            size = IconSize.LG
                        )
                    }

                    /** UPLOAD BUTTON **/

                    Row(
                        Modifier.margin(bottom = 10.px).fillMaxWidth().flexWrap(FlexWrap.Wrap),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        if (!hasUploaded && !isUploading){
                        CommonButton(
                            text = "Import $entityName",
                            icon = {
                                Image(
                                    src = Res.Images.upload_Cloud_Arrow,
                                    modifier = Modifier.size(20.px)
                                )
                            },
                            width = 150.px,
                            height = 40.px,
                            borderColor = sitePalette.primary.rgb,
                            backgroundColor = Colors.Transparent,
                            textSpanColor = sitePalette.primary.rgb,
                            onCLick = {
                                val input =
                                    document.getElementById(Res.Id.importCsv) as? HTMLInputElement
                                input?.click()
                            }
                        )
                            CustomSpacer(20.px)
                            CommonButton(
                                text = "Download Sample",
                                icon = {
                                    Image(
                                        src = Res.Images.download_Cloud_Arrow,
                                        modifier = Modifier.size(20.px)
                                    )
                                },
                                width = 160.px,
                                height = 40.px,
                                borderColor = sitePalette.primary.rgb,
                                backgroundColor = Colors.Transparent,
                                textSpanColor = sitePalette.primary.rgb,
                                onCLick = {
                                    val filePath = if (isCoach) {
                                       Res.Files.COACHES_CSV
                                    } else {
                                        Res.Files.PLAYERS_CSV
                                    }

                                    val link = (document.createElement("a") as HTMLAnchorElement).apply {
                                        href = filePath
                                        download = filePath.substringAfterLast("/")
                                    }
                                    document.body?.appendChild(link)
                                    link.click()
                                    document.body?.removeChild(link)
                                }
                            )
                            CustomSpacer(20.px)

                            CommonButton(
                                text = "Download Data",
                                icon = {
                                    Image(
                                        src = Res.Images.download_Cloud_Arrow,
                                        modifier = Modifier.size(20.px)
                                    )
                                },
                                width = 160.px,
                                height = 40.px,
                                borderColor = sitePalette.primary.rgb,
                                backgroundColor = Colors.Transparent,
                                textSpanColor = sitePalette.primary.rgb,
                                onCLick = {
                                        val (headers, rows) = if (isCoach) {
                                            val h = "email,firstName,lastName,season,teams"
                                            val r = coachesData.joinToString("\n") { coach ->
                                                val teams = coach.teams.joinToString(" , ") { it.teamID.extractTeamName() }    // joining multiple teams
                                                val season = coach.teams.joinToString(" ,   ") { it.seasonID.extractTeamName() }
                                                listOf(
                                                    coach.email,
                                                    coach.firstName,
                                                    coach.lastName,
                                                    season,
                                                    teams
                                                ).joinToString(",") { value ->
                                                    if (value.contains(",")) "\"$value\"" else value
                                                }
                                            }
                                            h to r
                                        } else {
                                            val h = "email,firstName,lastName,coachName,season,team"
                                            val r = playerData.joinToString("\n") { player ->
                                                val teams = player.teams.joinToString(" , ") { it.teamID.extractTeamName() }    // joining multiple teams
                                                val season = player.teams.joinToString(" ,   ") { it.seasonID.extractTeamName() }
                                                listOf(
                                                    player.email,
                                                    player.firstName,
                                                    player.lastName,
                                                    player.coachName,
                                                    season,
                                                    teams
                                                ).joinToString(",") { value ->
                                                    if (value.contains(",")) "\"$value\"" else value
                                                }
                                            }
                                            h to r
                                        }

                                        val csvContent = "$headers\n$rows"
                                        val fileName = if (isCoach) "coaches_data.csv" else "players_data.csv"
                                        val blob = Blob(
                                            arrayOf(csvContent),
                                            BlobPropertyBag(type = "text/csv;charset=utf-8;")
                                        )
                                        val url = URL.createObjectURL(blob)
                                        val link = (document.createElement("a") as HTMLAnchorElement).apply {
                                            href = url
                                            download = fileName
                                        }
                                        document.body?.appendChild(link)
                                        link.click()
                                        document.body?.removeChild(link)
                                        URL.revokeObjectURL(url)

                                }
                            )

                    }
                        if (hasUploaded) {
                            Row(
                                Modifier
                                    .fillMaxWidth()
                                    .margin(bottom = 5.px)
                                    .flexWrap(FlexWrap.Wrap)
                                    .rowGap(10.px),
                                horizontalArrangement = Arrangement.SpaceEvenly
                            ) {

                                StatCard("Total Imported", "${importedData?.totalRows ?: 0}", sitePalette)
                                StatCard("Created", "${importedData?.created ?: 0}", sitePalette)
                                StatCard("Skipped", "${importedData?.skipped ?: 0}", sitePalette)
                                StatCard("Errors", "${importedData?.errors ?: 0}", sitePalette)
                                StatCard(
                                    "Duration",
                                    "${(importedData?.durationSec ?: 0.0).toFixed(1)} Sec",
                                    sitePalette
                                )
                            }
                        }

                    }
                    if (hasUploaded){
                        Row (modifier = Modifier.fillMaxWidth().flexWrap(FlexWrap.Wrap),
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.SpaceBetween){
                            SearchBar(
                                placeholder = "Search Email...",
                                id = Res.Id.searchInput,
                                breakpoint = Breakpoint.LG,
                                modifier = Modifier.fillMaxWidth(),
                                onEnterClick = {},
                                onChange = { newSearchText ->
                                    searchText = newSearchText
                                },
                                onClick = {},
                                width = 300.px,
                                showClearButton = true
                            )

                            if (showMore) {
                                CommonButton(
                                    text = "Buy More Coaches",
                                    onCLick = {
                                        buyCoaches(true)
                                    },
                                    width = 145.px,
                                    height = 39.px
                                )
                            }
                        }
                    }


                    Box(
                        modifier = Modifier.width(if (isSmallScreen) 750.px else 100.percent)
                    ) {
                        if (isUploading) {
                            Box(
                                Modifier.fillMaxWidth().height(400.px),
                                contentAlignment = Alignment.Center
                            ) {
                                UploadingTextAnimation()
                            }
                        }

                        if (importDetails.isEmpty() && !isUploading) {
                            Box(
                                Modifier.fillMaxWidth().height(400.px),
                                contentAlignment = Alignment.Center
                            ) {
                                FieldTitleTextNormalSimple(
                                    "Upload the CSV file only to import $entityName list",
                                    fontSize = 15.px
                                )
                            }
                        }

                        Column(modifier = Modifier.fillMaxSize()) {
                            /** HEADER ROW **/
                            Row(
                                modifier = Modifier.fillMaxWidth().height(50.px)
                                    .padding(leftRight = 5.px)
                                    .margin(top = 5.px)
                                    .backgroundColor(sitePalette.coachesTitleRow.rgb),
                                verticalAlignment = Alignment.CenterVertically,
                                horizontalArrangement = Arrangement.SpaceBetween
                            ) {
                                FieldTitleTextNormalSimple(
                                    "Email",
                                    width = 230.px,
                                    fontWeight = 500,
                                    fontSize = 15.px
                                )
                                FieldTitleTextNormalSimple(
                                    "Status",
                                    width = 170.px,
                                    fontWeight = 500,
                                    fontSize = 13.px,
                                    textAlign = TextAlign.Center
                                )
                                FieldTitleTextNormalSimple(
                                    "Message",
                                    width = 350.px,
                                    fontWeight = 500,
                                    fontSize = 13.px,
                                    textAlign = TextAlign.Center
                                )
                            }

                            HorizontalDivider(
                                modifier = Modifier.fillMaxWidth()
                                    .height(0.5.px).margin(0.px)
                                    .backgroundColor(sitePalette.textFieldBorderColor.rgb)
                            )

                            /** SCROLLABLE DETAILS LIST **/
                            Column(
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .minHeight(400.px)
                                    .maxHeight(580.px)
                                    .overflow(
                                        overflowY = Overflow.Auto,
                                        overflowX = Overflow.Hidden
                                    )
                            ) {
                                filteredImportedData.forEach { details ->
                                    Column(modifier = Modifier.fillMaxWidth()) {
                                        Row(
                                            modifier = Modifier.fillMaxWidth()
                                                .padding(leftRight = 5.px, topBottom = 10.px),
                                            verticalAlignment = Alignment.CenterVertically,
                                            horizontalArrangement = Arrangement.SpaceBetween
                                        ) {
                                            FieldTitleTextNormalSimple(
                                                details.email,
                                                width = 230.px,
                                                fontSize = 13.px
                                            )
                                            FieldTitleTextNormalSimple(
                                                details.status.replaceFirstChar { it.uppercase() },
                                                width = 170.px,
                                                fontSize = 13.px,
                                                textAlign = TextAlign.Center
                                            )
                                            FieldTitleTextNormalSimple(
                                                details.reason,
                                                width = 350.px,
                                                fontSize = 13.px,
                                                textAlign = TextAlign.Center
                                            )
                                        }
                                        Divider()
                                    }
                                }
                            }
                        }
                    }
                }
            }

            /** HIDDEN FILE INPUT **/
            Input(
                type = InputType.File,
                attrs = {
                    id(Res.Id.importCsv)
                    accept(".csv, .xls, .xlsx")
                    style { display(DisplayStyle.None) }
                    onChange { event ->
                        val file = (event.target).files?.item(0)
                        if (file != null) {
                            scope.launch {
                                try {
                                    isUploading = true
                                    val response = if (isCoach) {
                                        importCoach(file)
                                    } else {
                                        importPlayer(file)
                                    }
                                    if (response.details.any { it.reason.contains("max coaches reached", ignoreCase = true) }) {
                                        showMore = true
                                    }
                                    if (response.details.any { it.reason.contains("Upload rejected:", ignoreCase = true) }) {
                                        toastMessage(response.error!!)
                                        showToast(ToastID.ERROR)
                                    }
                                    if (response.errors == response.totalRows){
                                        hasUploaded = false
                                        toastMessage(response.details.first().reason)
                                        showToast(ToastID.ERROR)
                                    }
                                    else {
                                     hasUploaded = true
                                    toastMessage("File Uploaded Successfully")
                                    showToast(ToastID.SUCCESS)
                                     importedData = response
                                    importDetails.clear()
                                    importDetails.addAll(response.details)}

                                } catch (e: Exception) {
                                    toastMessage(e.message.toString())
                                    showToast(ToastID.ERROR)
                                    hasUploaded = false

                                } finally {
                                    isUploading = false
                                    val inputEl = document.getElementById(Res.Id.importCsv) as? HTMLInputElement
                                    inputEl?.value = ""
                                }
                            }
                        }
                    }
                }
            )
        }
    }
}

@Composable
fun StatCard(label: String, value: String, sitePalette: SitePalette) {
    val isSmallScreen = window.innerWidth <= 600

    Box(
        modifier = Modifier
            .width(if (isSmallScreen) 48.percent else 150.px)
            .padding(8.px)
            .backgroundColor(Colors.White)
            .borderRadius(6.px)
            .border(
                width = 1.px,
                color = sitePalette.textFieldBorderColor.rgb,
                style = LineStyle.Solid
            ),
        contentAlignment = Alignment.Center
    ) {
        Column(horizontalAlignment = Alignment.CenterHorizontally) {
            FieldTitleTextNormalSimple(label, fontSize = 12.px)
            FieldTitleTextNormalSimple(value, fontSize = 16.px, fontWeight = 600)
        }
    }
}
